module.exports = __webpack_public_path__ + "img/hex.22411f76.png";